import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { SignAttendanceSheetBody, SignAttendanceSheetResponse } from "@shared-kernel/application/ports/student/student-repository";

export const signAttendanceSheet = createAsyncThunk<SignAttendanceSheetResponse, SignAttendanceSheetBody, { extra: Partial<Dependencies> }>(
  "trainingFollowUps/signAttendanceSheet",
  async (payload: SignAttendanceSheetBody, { extra: { studentRepository } }) => {
    return studentRepository!.signAttendanceSheet(payload);
  },
);
